import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ModalService } from '../../../shared/components/modal/modal.service';
import { AuthStore } from '../../../core/auth/auth.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-account-switch-notification',
    templateUrl: './account-switch-notification.component.html',
    imports: [TranslatePipe],
    styles: ``,
})
export class AccountSwitchNotificationComponent implements OnInit, OnDestroy {
    countdown: number = 3;
    private sub!: Subscription;
    private modalService = inject(ModalService);
    private authStore = inject(AuthStore);

    ngOnInit() {
        this.sub = interval(1000)
            .pipe(take(4)) // 3...2...1...0 then complete
            .subscribe(count => {
                this.countdown = 3 - count;
                if (this.countdown === 0) {
                    this.handleRedirect();
                }
            });
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }

    handleRedirect() {
        this.modalService.close();
        this.authStore.logout();
        // console.log('Redirecting to selected account...');
    }
}
